var exports = {
  "header": "x24da60e8--f226d0--header",
  "list": "x24da60e8--f226d0--list",
  "options": "x24da60e8--f226d0--options",
  "options-checkbox": "x24da60e8--f226d0--options-checkbox",
  "not-found": "x24da60e8--f226d0--not-found",
  "buttons": "x24da60e8--f226d0--buttons",
  "action-area": "x24da60e8--f226d0--action-area",
  "action-wrapper-when-sticky": "x24da60e8--f226d0--action-wrapper-when-sticky",
};

module.exports = exports;
